// extracted by mini-css-extract-plugin
module.exports = {"RiveMark":"NavIcon_RiveMark__05Fhe"};